import React from 'react';
import { RaffleData } from '../../../../adapters/RaffleAdapter';
import { RaffleCard } from './Raffle.Card';
import styles from './Raffle.module.css';

interface RaffleCarouselProps {
  raffles: RaffleData[];
}

export const RaffleCarousel: React.FC<RaffleCarouselProps> = ({ raffles }) => {
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carousel}>
        {raffles.map((raffle) => (
          <div key={raffle.id} className={styles.carouselItem}>
            <RaffleCard raffle={raffle} />
          </div>
        ))}
      </div>
    </div>
  );
}; 